// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.main-layout {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-layout .main-header {
  flex: 0 0 auto;
}
.main-layout .main-content {
  flex: 1 1 auto;
  align-items: stretch;
  overflow-y: auto;
}

:host ::ng-deep .page-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .page-layout .page-header {
  flex: 0 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 76px;
}
:host ::ng-deep .page-layout .page-header .btn {
  padding: 5px 15px;
}
:host ::ng-deep .page-layout .page-content {
  flex: 1 1 auto;
  overflow-y: auto;
}
:host ::ng-deep .card.page-layout {
  border-radius: 0;
  border-left-width: 0;
  border-right-width: 0;
}
:host ::ng-deep .card.page-layout .card-header.page-header {
  border-radius: 0;
}
:host ::ng-deep .navbar-light {
  box-shadow: 0 2px 15px 0 rgba(0, 73, 109, 0.1);
}
:host ::ng-deep .navbar-brand img {
  height: 25px;
}
:host ::ng-deep a {
  font-size: 16px;
  font-weight: bold;
}
:host ::ng-deep a i-feather {
  margin-right: 14px;
  height: 18px !important;
  width: 18px !important;
}
:host ::ng-deep a.btn {
  font-size: 1rem;
}
:host ::ng-deep i-feather.plusicon::ng-deep {
  width: 18px;
  height: 18px;
}
:host ::ng-deep i-feather.plusicon::ng-deep svg {
  position: relative;
  top: -2px;
  width: 18px;
  height: 18px;
}
:host ::ng-deep i-feather.fms-icon::ng-deep {
  height: 20px;
}
:host ::ng-deep i-feather.fms-icon::ng-deep svg {
  position: relative;
  height: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-delete-icon::ng-deep {
  height: 20px;
  color: #f64540;
  cursor: pointer;
}
:host ::ng-deep i-feather.fms-delete-icon::ng-deep svg {
  position: relative;
  height: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-add-icon::ng-deep {
  height: 20px !important;
  width: 20px !important;
  color: #1ba953;
}
:host ::ng-deep i-feather.fms-add-icon::ng-deep svg {
  position: relative;
  height: 20px;
  width: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-cancel-icon::ng-deep {
  height: 20px !important;
  width: 20px !important;
  color: #f64540;
}
:host ::ng-deep i-feather.fms-cancel-icon::ng-deep svg {
  position: relative;
  height: 20px;
  width: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-input-icon::ng-deep {
  position: absolute;
  top: -1px;
  right: 21px;
  z-index: 2;
  display: block;
  width: 25px;
  height: 25px;
  line-height: 34px;
  text-align: center;
  pointer-events: none;
}
:host ::ng-deep .circle-icon {
  font-size: 25px;
}
:host ::ng-deep .circle-icon i-feather {
  height: 24px !important;
  width: 24px !important;
}
:host ::ng-deep .file-icon {
  height: 80px;
  width: 100%;
  fill: #1161be;
}
:host ::ng-deep .dropdown-menu {
  margin-top: 10px;
}
:host ::ng-deep .dropdown-menu .nav-link {
  white-space: nowrap;
}
:host ::ng-deep .fms-lb-background {
  background: #e1eefe;
}
:host ::ng-deep ngx-dropzone.fms-dropzone {
  background: #e1eefe;
  height: 80px;
  border: dashed 1px #1161be;
}
:host ::ng-deep ngx-dropzone.fms-dropzone.has-files {
  height: 180px;
}
:host ::ng-deep .fms-footer {
  position: absolute;
  bottom: 20px;
  width: 100%;
}
:host ::ng-deep .pull-right {
  float: right;
}
:host ::ng-deep .pull-left {
  float: left;
}
:host ::ng-deep .fms-grey-text {
  font-family: "Noto Sans";
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #252525;
}
:host ::ng-deep button.fms-button {
  height: 40px;
  min-width: 94px;
  border-radius: 4px !important;
  border: solid 2px #1161be !important;
  font-family: "Noto Sans";
  font-size: 16px !important;
  font-weight: bold !important;
}
:host ::ng-deep label.required:after {
  color: #f64540;
  content: " *";
}
:host ::ng-deep label {
  font-family: "Noto Sans";
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
:host ::ng-deep .custom-control-label {
  vertical-align: top;
}
:host ::ng-deep input.ng-touched.ng-invalid:not(.skip-validation-style), :host ::ng-deep select.ng-touched.ng-invalid:not(.skip-validation-style), :host ::ng-deep textarea.ng-touched.ng-invalid:not(.skip-validation-style) {
  border-color: #f64540;
}
:host ::ng-deep ng-multiselect-dropdown.ng-touched.ng-invalid span.dropdown-btn:not(.skip-validation-style) {
  border-color: #f64540;
}
:host ::ng-deep select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #8291ae 50%), linear-gradient(135deg, #8291ae 50%, transparent 50%), linear-gradient(to right, #fff, #fff);
  background-position: calc(100% - 15px) 1em, calc(100% - 10px) 1em, 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;
}
:host ::ng-deep span.dropdown-down {
  border-top: 5px solid #8291ae !important;
  border-left: 5px solid transparent !important;
  border-right: 5px solid transparent !important;
}
:host ::ng-deep span.dropdown-up {
  border-bottom: 5px solid #8291ae !important;
  border-left: 5px solid transparent !important;
  border-right: 5px solid transparent !important;
}
:host ::ng-deep ng-multiselect-dropdown::ng-deep .dropdown-list {
  margin-top: 0;
}

row {
  margin-left: -10px o !important;
}

.form-col {
  flex: 0 0 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 768px) {
  .form-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

.book-number,
.page-number {
  flex: 0 0 50%;
}
@media (min-width: 768px) {
  .book-number,
  .page-number {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.book-number {
  padding-left: 15px;
  padding-right: 10px;
  order: 2;
}

.page-number {
  order: 3;
  padding-right: 15px;
}

.id-number {
  order: 1;
}

.id-issue {
  order: 4;
}

@media (min-width: 768px) {
  .book-number {
    order: 3;
  }
  .page-number {
    order: 4;
  }
  .id-number {
    order: 1;
  }
  .id-issue {
    order: 2;
  }
}
.connection-address-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.connection-address-container .location,
.connection-address-container .address {
  width: 100%;
}
.connection-address-container .address {
  margin-top: 10px;
}
@media (min-width: 768px) {
  .connection-address-container {
    flex-direction: row;
  }
  .connection-address-container .location {
    width: 50%;
    padding-right: 10px;
  }
  .connection-address-container .address {
    width: 50%;
    padding-left: 10px;
    margin-top: 0;
  }
}

.contract-btn {
  display: flex;
  width: 213px;
  margin: auto;
  margin-top: auto;
  padding: 15px 15px;
  color: green;
  border: none;
  border-bottom: 1px solid green;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: none;
}

.contract-btn.signed {
  color: grey;
  border-bottom: 1px solid grey;
  width: 184px;
  padding: 15px 23px;
}

.contract-modal-backdrop {
  display: flex;
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
}

.contract-modal {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  width: 80vw;
  max-width: 943px;
  height: 80vh;
  max-height: 726px;
  display: flex;
  flex-direction: column;
  align-content: space-between;
}

.contract-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  cursor: pointer;
  border: none;
  background: none;
  font-size: large;
}

.signature-modal {
  aspect-ratio: 36/11;
  background-color: #fff;
}

.contract-modal-content {
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 20px 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15px;
}
.contract-modal-content .grid-container {
  display: grid;
  grid-template-columns: 30% 30% 30%;
  grid-gap: 10px;
  grid-column-gap: 30px;
}
.contract-modal-content .grid-item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
.contract-modal-content .grid-item .title {
  font-size: 12px;
  margin-bottom: 10px;
}
.contract-modal-content .grid-item .content {
  font-size: 16px;
  font-weight: bold;
  width: 100%;
}
.contract-modal-content .grid-item .content img {
  width: 100%;
}
.contract-modal-content .grid-item .signature-thumbnail {
  aspect-ratio: 270.9/93.85;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 200;
  background-position: center;
  background-size: 100% 100%;
}
.contract-modal-content .grid-item .stamp {
  margin-top: 28px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.contract-modal-content .grid-item .stamp img {
  transform: rotate(-37deg);
  width: 65%;
}
.contract-modal-content .signature-pad-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.contract-modal-content .signature-pad-container .controls {
  display: flex;
  justify-content: flex-start;
  max-width: 560px;
}
.contract-modal-content signature-pad {
  border: 1px solid #e4e4e4;
  border-radius: 3px;
}
.contract-modal-content signature-pad canvas {
  border: 1px solid red;
}

.contract-modal-footer {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

@media (max-width: 1035px) {
  .contract-modal-content .grid-container {
    grid-template-columns: 1fr;
    -moz-column-gap: 15px;
         column-gap: 15px;
  }
  .contract-modal-content .grid-container .grid-item .title {
    margin-top: 10px;
  }
  .contract-modal-content .grid-container .grid-item .stamp {
    margin-top: 10px;
  }
  .contract-modal-content .grid-container .grid-item .stamp img {
    transform: rotate(0deg);
    width: 100%;
  }
}
@media (max-width: 1035px) and (max-width: 736px) {
  .contract-modal {
    width: 90vw;
    max-width: auto;
  }
}
.contract-description {
  direction: rtl;
  text-align: initial;
  padding-inline-start: 20px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/layout/main-layout/main-layout.component.scss","webpack://./src/app/tasks/task-view/task-customer-acquisition/customer-acquisition-form/customer-acquisition-form.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC9LA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ACYF;ADVE;EACE,cAAA;ACYJ;ADTE;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;ACWJ;;ADNE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;ACSJ;ADPI;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;ACSN;ADPM;EACE,iBAAA;ACSR;ADLI;EACE,cAAA;EACA,gBAAA;ACON;ADHE;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;ACKJ;ADHI;EACE,gBAAA;ACKN;ADDE;EACE,8CAAA;ACGJ;ADCI;EACE,YAAA;ACCN;ADGE;EACE,eAAA;EACA,iBAAA;ACDJ;ADGI;EACE,kBAAA;EAEA,uBAAA;EACA,sBAAA;ACFN;ADME;EACE,eAAA;ACJJ;ADOE;EACE,WAAA;EACA,YAAA;ACLJ;ADOI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;ACLN;ADSE;EACE,YAAA;ACPJ;ADSI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;ACPN;ADWE;EACE,YAAA;EACA,cDrEM;ECsEN,eAAA;ACTJ;ADWI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;ACTN;ADaE;EACE,uBAAA;EACA,sBAAA;EACA,cD9FQ;AEmFZ;ADaI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;ACXN;ADeE;EACE,uBAAA;EACA,sBAAA;EACA,cD/FM;AEkFV;ADeI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;ACbN;ADiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;ACfJ;ADkBE;EACE,eAAA;AChBJ;ADkBI;EACE,uBAAA;EACA,sBAAA;AChBN;ADoBE;EACE,YAAA;EACA,WAAA;EACA,aDzJO;AEuIX;ADqBE;EAEE,gBAAA;ACpBJ;ADsBI;EACE,mBAAA;ACpBN;ADwBE;EACE,mBDpKa;AE8IjB;AD2BI;EACE,mBD1KW;EC2KX,YAAA;EACA,0BAAA;ACzBN;AD2BI;EACE,aAAA;ACzBN;AD6BE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AC3BJ;AD8BE;EACE,YAAA;AC5BJ;AD+BE;EACE,WAAA;AC7BJ;ADgCE;EACE,wBD3Jc;EC4Jd,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cDxMY;AE0KhB;ADiCE;EACE,YAAA;EACA,eAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBD1Kc;EC2Kd,0BAAA;EACA,4BAAA;AC/BJ;ADkCE;EACE,cDlMM;ECmMN,aAAA;AChCJ;ADmCE;EACE,wBDrLc;ECsLd,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;ACjCJ;ADoCE;EACE,mBAAA;AClCJ;ADqCE;EACE,qBDrNM;AEkLV;ADsCE;EACE,qBDzNM;AEqLV;ADuCE;EAEE,wBAAA;EACA,qBAAA;EAEA,oKAAA;EAGA,yEAAA;EAGA,8CAAA;EAGA,4BAAA;AC7CJ;ADgDE;EACE,wCAAA;EACA,6CAAA;EACA,8CAAA;AC9CJ;ADiDE;EACE,2CAAA;EACA,6CAAA;EACA,8CAAA;AC/CJ;ADmDI;EACE,aAAA;ACjDN;;AA1OA;EACE,+BAAA;AA6OF;;AA1OA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AA6OF;AA3OE;EALF;IAMI,aAAA;IACA,cAAA;EA8OF;AACF;;AA3OA;;EAEE,aAAA;AA8OF;AA5OE;EAJF;;IAKI,aAAA;IACA,cAAA;EAgPF;AACF;;AA7OA;EACE,kBAAA;EACA,mBAAA;EACA,QAAA;AAgPF;;AA7OA;EACE,QAAA;EACA,mBAAA;AAgPF;;AA7OA;EACE,QAAA;AAgPF;;AA7OA;EACE,QAAA;AAgPF;;AA7OA;EACE;IACE,QAAA;EAgPF;EA7OA;IACE,QAAA;EA+OF;EA5OA;IACE,QAAA;EA8OF;EA3OA;IACE,QAAA;EA6OF;AACF;AA1OA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;AA4OF;AA1OE;;EAEE,WAAA;AA4OJ;AAzOE;EACE,gBAAA;AA2OJ;AAxOE;EAfF;IA2BI,mBAAA;EAgOF;EA3OE;IACE,UAAA;IACA,mBAAA;EA6OJ;EA1OE;IACE,UAAA;IACA,kBAAA;IACA,aAAA;EA4OJ;AACF;;AAtOA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAyOF;;AAtOA;EACE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AAyOF;;AAtOA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,mBAAA;AAyOF;;AAtOA;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AAyOF;;AAtOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAyOF;;AAtOA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAyOF;;AAvOA;EACE,mBAAA;EACA,sBAAA;AA0OF;;AAxOA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;AA2OF;AA1OE;EACE,aAAA;EACA,kCAAA;EACA,cAAA;EACA,qBAAA;AA4OJ;AA1OE;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;AA4OJ;AA3OI;EACE,eAAA;EACA,mBAAA;AA6ON;AA3OI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AA6ON;AA5OM;EACE,WAAA;AA8OR;AA3OI;EACE,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;AA6ON;AA3OI;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA6ON;AA5OM;EACE,yBAAA;EACA,UAAA;AA8OR;AAzOE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA2OJ;AA1OI;EACE,aAAA;EACA,2BAAA;EACA,gBAAA;AA4ON;AAzOE;EACE,yBAAA;EACA,kBAAA;AA2OJ;AA1OI;EACE,qBAAA;AA4ON;;AAvOA;EACE,aAAA;EACA,2BAAA;EACA,SAAA;AA0OF;;AAvOA;EACE;IACE,0BAAA;IACA,qBAAA;SAAA,gBAAA;EA0OF;EAxOI;IACE,gBAAA;EA0ON;EAxOI;IACE,gBAAA;EA0ON;EAzOM;IACE,uBAAA;IACA,WAAA;EA2OR;AACF;AAvOE;EACE;IACE,WAAA;IACA,eAAA;EAyOJ;AACF;AArOA;EACE,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AAuOF","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../styles/variables\";\n\n.main-layout {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n\n  .main-header {\n    flex: 0 0 auto;\n  }\n\n  .main-content {\n    flex: 1 1 auto;\n    align-items: stretch;\n    overflow-y: auto;\n  }\n}\n\n:host ::ng-deep {\n  .page-layout {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .page-header {\n      flex: 0 0 auto;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      min-height: 76px;\n\n      .btn {\n        padding: 5px 15px;\n      }\n    }\n\n    .page-content {\n      flex: 1 1 auto;\n      overflow-y: auto;\n    }\n  }\n\n  .card.page-layout {\n    border-radius: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n\n    .card-header.page-header {\n      border-radius: 0;\n    }\n  }\n\n  .navbar-light {\n    box-shadow: 0 2px 15px 0 rgba(0, 73, 109, 0.1);\n  }\n\n  .navbar-brand {\n    img {\n      height: 25px;\n    }\n  }\n\n  a {\n    font-size: 16px;\n    font-weight: bold;\n\n    i-feather {\n      margin-right: 14px;\n\n      height: 18px !important;\n      width: 18px !important;\n    }\n  }\n\n  a.btn {\n    font-size: 1rem;\n  }\n\n  i-feather.plusicon::ng-deep {\n    width: 18px;\n    height: 18px;\n\n    svg {\n      position: relative;\n      top: -2px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  i-feather.fms-icon::ng-deep {\n    height: 20px;\n\n    svg {\n      position: relative;\n      height: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-delete-icon::ng-deep {\n    height: 20px;\n    color: $fms-red;\n    cursor: pointer;\n\n    svg {\n      position: relative;\n      height: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-add-icon::ng-deep {\n    height: 20px !important;\n    width: 20px !important;\n    color: $fms-green;\n\n    svg {\n      position: relative;\n      height: 20px;\n      width: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-cancel-icon::ng-deep {\n    height: 20px !important;\n    width: 20px !important;\n    color: $fms-red;\n\n    svg {\n      position: relative;\n      height: 20px;\n      width: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-input-icon::ng-deep {\n    position: absolute;\n    top: -1px;\n    right: 21px;\n    z-index: 2;\n    display: block;\n    width: 25px;\n    height: 25px;\n    line-height: 34px;\n    text-align: center;\n    pointer-events: none;\n  }\n\n  .circle-icon {\n    font-size: 25px;\n\n    i-feather {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n\n  .file-icon {\n    height: 80px;\n    width: 100%;\n    fill: $fms-blue;\n  }\n\n  .dropdown-menu {\n\n    margin-top: 10px;\n\n    .nav-link {\n      white-space: nowrap;\n    }\n  }\n\n  .fms-lb-background {\n    background: $fms-blue-light;\n  }\n\n  ngx-dropzone {\n\n    &.fms-dropzone {\n      background: $fms-blue-light;\n      height: 80px;\n      border: dashed 1px $fms-blue;\n    }\n    &.fms-dropzone.has-files {\n      height: 180px;\n    }\n  }\n\n  .fms-footer {\n    position: absolute;\n    bottom: 20px;\n    width: 100%;\n  }\n\n  .pull-right {\n    float: right;\n  }\n\n  .pull-left {\n    float: left;\n  }\n\n  .fms-grey-text {\n    font-family: $fms-font-family;\n    font-size: 15px;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: $fms-gray-dark;\n  }\n\n  button.fms-button {\n    height: 40px;\n    min-width: 94px;\n    border-radius: 4px !important;\n    border: solid 2px $fms-blue !important;\n    font-family: $fms-font-family;\n    font-size: 16px !important;\n    font-weight: bold !important;\n  }\n\n  label.required:after {\n    color: $fms-red;\n    content: ' *';\n  }\n\n  label {\n    font-family: $fms-font-family;\n    font-size: 16px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n  }\n\n  .custom-control-label {\n    vertical-align: top;\n  }\n\n  input.ng-touched.ng-invalid:not(.skip-validation-style), select.ng-touched.ng-invalid:not(.skip-validation-style), textarea.ng-touched.ng-invalid:not(.skip-validation-style) {\n    border-color: $fms-red;\n  }\n\n  ng-multiselect-dropdown.ng-touched.ng-invalid span.dropdown-btn:not(.skip-validation-style) {\n    border-color: $fms-red;\n  }\n\n  select {\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    background-image: linear-gradient(45deg, transparent 50%, $fms-gray 50%),\n    linear-gradient(135deg, $fms-gray 50%, transparent 50%),\n    linear-gradient(to right, $fms-white, $fms-white);\n    background-position: calc(100% - 15px) calc(1em),\n    calc(100% - 10px) calc(1em),\n    100% 0;\n    background-size: 5px 5px,\n    5px 5px,\n    2.5em 2.5em;\n    background-repeat: no-repeat;\n  }\n\n  span.dropdown-down {\n    border-top: 5px solid $fms-gray !important;\n    border-left: 5px solid transparent !important;\n    border-right: 5px solid transparent !important;\n  }\n\n  span.dropdown-up {\n    border-bottom: 5px solid $fms-gray !important;\n    border-left: 5px solid transparent !important;\n    border-right: 5px solid transparent !important;\n  }\n\n  ng-multiselect-dropdown::ng-deep {\n    .dropdown-list {\n      margin-top: 0;\n    }\n  }\n}\n","@import '../../../../layout/main-layout/main-layout.component.scss';\nrow {\n  margin-left: -10px o !important;\n}\n\n.form-col {\n  flex: 0 0 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n\n  @media (min-width: 768px) {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n\n.book-number,\n.page-number {\n  flex: 0 0 50%;\n\n  @media (min-width: 768px) {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n}\n\n.book-number {\n  padding-left: 15px;\n  padding-right: 10px;\n  order: 2;\n}\n\n.page-number {\n  order: 3;\n  padding-right: 15px;\n}\n\n.id-number {\n  order: 1;\n}\n\n.id-issue {\n  order: 4;\n}\n\n@media (min-width: 768px) {\n  .book-number {\n    order: 3;\n  }\n\n  .page-number {\n    order: 4;\n  }\n\n  .id-number {\n    order: 1;\n  }\n\n  .id-issue {\n    order: 2;\n  }\n}\n\n.connection-address-container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .location,\n  .address {\n    width: 100%;\n  }\n\n  .address {\n    margin-top: 10px;\n  }\n\n  @media (min-width: 768px) {\n    .location {\n      width: 50%;\n      padding-right: 10px;\n    }\n\n    .address {\n      width: 50%;\n      padding-left: 10px;\n      margin-top: 0;\n    }\n\n    flex-direction: row;\n  }\n}\n\n.contract-btn {\n  display: flex;\n  width: 213px;\n  margin: auto;\n  margin-top: auto;\n  padding: 15px 15px;\n  color: green;\n  border: none;\n  border-bottom: 1px solid green;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background: none;\n}\n\n.contract-btn.signed {\n  color: grey;\n  border-bottom: 1px solid grey;\n  width: 184px;\n  padding: 15px 23px;\n}\n\n.contract-modal-backdrop {\n  display: flex;\n  z-index: 101;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  justify-content: center;\n  align-items: center;\n}\n\n.contract-modal {\n  background-color: white;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  width: 80vw;\n  max-width: 943px;\n  height: 80vh;\n  max-height: 726px;\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n}\n\n.contract-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.close-btn {\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-size: large;\n}\n.signature-modal {\n  aspect-ratio: 36/11;\n  background-color: #fff;\n}\n.contract-modal-content {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  margin: 20px 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-bottom: 15px;\n  .grid-container {\n    display: grid;\n    grid-template-columns: 30% 30% 30%;\n    grid-gap: 10px;\n    grid-column-gap: 30px;\n  }\n  .grid-item {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: column;\n    .title {\n      font-size: 12px;\n      margin-bottom: 10px;\n    }\n    .content {\n      font-size: 16px;\n      font-weight: bold;\n      width: 100%;\n      img {\n        width: 100%;\n      }\n    }\n    .signature-thumbnail {\n      aspect-ratio: 270.9/93.85;\n      background-color: #eee;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 3px;\n      cursor: pointer;\n      font-size: 12px;\n      font-weight: 200;\n      background-position: center;\n      background-size: 100% 100%;\n    }\n    .stamp {\n      margin-top: 28px;\n      display: flex;\n      align-content: center;\n      justify-content: center;\n      img {\n        transform: rotate(-37deg);\n        width: 65%;\n      }\n    }\n  }\n\n  .signature-pad-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    .controls {\n      display: flex;\n      justify-content: flex-start;\n      max-width: 560px;\n    }\n  }\n  signature-pad {\n    border: 1px solid #e4e4e4;\n    border-radius: 3px;\n    canvas {\n      border: 1px solid red;\n    }\n  }\n}\n\n.contract-modal-footer {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n@media (max-width: 1035px) {\n  .contract-modal-content .grid-container {\n    grid-template-columns: 1fr;\n    column-gap: 15px;\n    .grid-item {\n      .title {\n        margin-top: 10px;\n      }\n      .stamp {\n        margin-top: 10px;\n        img{\n          transform: rotate(0deg);\n          width: 100%;\n        }\n      }\n    }\n  }\n  @media (max-width: 736px) {\n    .contract-modal {\n      width: 90vw;\n      max-width: auto;\n    }\n  }\n}\n\n.contract-description {\n  direction: rtl;\n  text-align: initial;\n  padding-inline-start: 20px;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
